import React, { useState, useEffect } from "react";
import judul from "../components/image/judul.png";
import backgroundMusic from "../components/music/home.ogg";
import ButtonMute from "../components/ButtonMusic";
import ButtonPlay from "../components/ButtonPlay";
import ButtonInfo from "../components/ButtonInfo";
import ButtonFull from "../components/buttonfull";
import StoryModal from "../components/ModalStory";
import ButtonHistory from "../components/ButtonHistory";
import "../App.css";
import ModalHistory from "../components/ModalHistory";
import Preloader from '../components/preloader';
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "../components/language/en/translation_en.json";
import translationID from "../components/language/id/translation_id.json";
import ButtonLanguage from "../components/ButtonLanguage";

const resources = {
  en: {
    translation: translationEN,
  },
  id: {
    translation: translationID,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});
const Home = () => {
  const { t } = useTranslation();
  const [showStoryModal, setShowStoryModal] = useState(false);
  const [showhistoryModal, setShowHistoryModal] = useState(false);
  const [showRotateMessage, setShowRotateMessage] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [isLoading, setIsLoading] = useState(true);  
  

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 4000);

    return () => clearTimeout(timer);
  }, []);

   const categories = [
     ["Animals", "animals"],
     ["Parts of the body ", "body"],
     ["Professions", "profession"],
     ["Things in the classroom ", "classroom"],
     ["Things in the kitchen ", "kitchen"],
     ["Things in the bedroom", "bedroom"],
     ["Things in the living room ", "livingroom"],
   ];

  const handleMuteToggle = () => {
    console.log("Mute button clicked");
  };

  const handleOpenStoryModal = () => {
    setShowStoryModal(true);
  };

  const handleCloseStoryModal = () => {
    setShowStoryModal(false);
  };

  const handleOpenHistoryModal = () => {
    setShowHistoryModal(true);
  };

  const handleCloseHistoryModal = () => {
    setShowHistoryModal(false);
  };
  
  const checkOrientation = () => {
    if (window.innerHeight > window.innerWidth) {
      setShowRotateMessage(true);
    } else {
      setShowRotateMessage(false);
    }
  };

  const handleFullscreenChange = () => {
    if (document.fullscreenElement) {
      setIsFullscreen(true);
    } else {
      setIsFullscreen(false);
    }
  };

  const toggleFullscreen = () => {
    if (!isFullscreen) {
      document.documentElement.requestFullscreen().catch((err) => {
        console.error(`Failed to enable fullscreen mode: ${err.message}`);
      });
    } else {
      document.exitFullscreen().catch((err) => {
        console.error(`Failed to exit fullscreen mode: ${err.message}`);
      });
    }
  };

  useEffect(() => {
    document.title = "Congklak Champs - Home";
    checkOrientation();
    window.addEventListener("resize", checkOrientation);
    document.addEventListener("fullscreenchange", handleFullscreenChange);

    try {
      const gameHistory = localStorage.getItem("gameDakonHistory");

      if (!gameHistory || gameHistory.length === 0) {
        console.log("No game history found, closing modal...");
        setShowStoryModal(true);
      }
    } catch (error) {
      console.error("Error accessing localStorage:", error);
      setShowStoryModal(false);
    }

    if (document.fullscreenElement) {
      setIsFullscreen(true);
    } else {
      setIsFullscreen(false);
    }

    return () => {
      window.removeEventListener("resize", checkOrientation);
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
  };

  return (
    <>
      {isLoading ? (
        <Preloader />
      ) : (
        <>
          {showRotateMessage && (
            <div id="rotate-message">{t("rotate_device")}</div>
          )}
          <div className="home flex flex-col items-center justify-center min-h-screen bg-game relative">
            <div className="button-container absolute right-5 z-30 justify-between">
              <div className="right-5 z-30 flex gap-3">
                <ButtonFull
                  isFullscreen={isFullscreen}
                  onClick={toggleFullscreen}
                  className="top-left-button"
                />
                <ButtonInfo
                  onClick={handleOpenStoryModal}
                  className="top-right-button"
                />
                <audio
                  id="background-audio"
                  src={backgroundMusic}
                  autoPlay
                  loop
                />
                <ButtonMute onClick={handleMuteToggle} />
                <ButtonHistory
                  onClick={handleOpenHistoryModal}
                  className="top-right-button"
                />
                <ButtonLanguage/>
              </div>
            </div>

            <img
              src={judul}
              alt="judul"
              className="w-2/4 md:w-1/3 lg:w-1/3 my-1 judul-game"
            />

            <div className="kategori flex flex-col items-center mt-4">
              <select
                value={selectedCategory}
                onChange={handleCategoryChange}
                className="relative inline-block w-full rounded-full border-4 sm:border-2 border-[#dddddd] shadow-sm lg:px-8 lg:py-3 sm:px-2 sm:py-1 text-sm bg-[#ff3636] lg:text-md sm:text-sm font-medium text-white hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-red-500"
              >
                <option value="">{t("question_category")}</option>
                {categories.map((category) => (
                  <option key={category} value={category[1]}>
                    {category[0]}
                  </option>
                ))}
              </select>
            </div>

            {selectedCategory && (
              <ButtonPlay
                text={t("play")}
                link="/game"
                selectedCategory={selectedCategory}
              />
            )}

            <StoryModal
              show={showStoryModal}
              handleClose={handleCloseStoryModal}
            />
            <ModalHistory
              show={showhistoryModal}
              handleClose={handleCloseHistoryModal}
            />
          </div>
        </>
      )}
    </>
  );
  
};

export default Home;
